// // Authenticate.js
// import { useStytchSession } from "@stytch/react";
// import { Navigate } from "react-router-dom";
// import LoginScreen from "../screens/LoginScreenB2B";

// const Authenticate = () => {
//   const { session, isInitialized } = useStytchSession();

//   if (session) {
//     console.log("True", session);
//     return <Navigate to="/" />;
//   }

//   return <LoginScreen />;
// };

// export default Authenticate;

// src/authentication/Authenticate.js
import {
  Box,
  Card,
  CircularProgress,
  Container,
  List,
  ListItem,
  Typography,
} from "@mui/material";
import { grey, red } from "@mui/material/colors";
import { useStytch, useStytchSession } from "@stytch/react";
import { useEffect, useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import Flx from "../components/layout/Flx";
import Txt from "../components/typography/Txt";

import magicLinkGuide from "../assets/stytch-login-troubleshoot.png";
const Authenticate = () => {
  const stytch = useStytch();
  const { session, isCached } = useStytchSession();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [error, setError] = useState("");

  useEffect(() => {
    // (Optionally) wait for initial cache hydration to finish:
    // if (isCached) return;

    // Already signed in?
    if (session) {
      navigate("/", { replace: true });
      return;
    }

    const token = searchParams.get("token");
    if (!token) {
      setError("No magic-link token found in URL.");
      return;
    }

    (async () => {
      try {
        await stytch.magicLinks.authenticate(token, {
          session_duration_minutes: 10080,
        });
        navigate("/", { replace: true });
      } catch (err) {
        console.error("Stytch authenticate error:", err);
        setError(err.message || "Authentication failed.");
      }
    })();
  }, [
    /* no isInitialized */
    session,
    searchParams,
    stytch,
    navigate,
  ]);
  const t =
    "[400] pkce_expected_code_verifier This flow was started using a code_challenge but the authentication call is missing the corresponding code_verifier. See https://stytch.com/docs/api/errors/400#pkce_expected_code_verifier for more information. request_id: request-id-live-c8b9d827-7d5c-4c48-8a6b-9f468af044c6";

  if (error) {
    return (
      <Container maxWidth="lg">
        <Flx column gap={2}>
          <Box sx={{ p: 4, textAlign: "center" }}>
            <Typography variant="h4" color="error" gutterBottom>
              Authentication Error
            </Typography>
            <Flx sx={{ p: 2, background: red[50], borderRadius: 1 }}>
              <Typography>{error}</Typography>
            </Flx>
          </Box>
          <Box sx={{ p: 4 }}>
            <Typography variant="h4" gutterBottom>
              Troubleshooting
            </Typography>
            <Card sx={{ p: 3, borderRadius: 1 }}>
              <Flx column gap={4}>
                <Flx column gap={1}>
                  <Txt bold>Important</Txt>
                  <Txt>
                    To ensure the magic link login works correctly, you must{" "}
                    <b>open the email link in the same browser</b> you used to
                    request the link. To continue with this browser,{" "}
                    <Link to={"/login"}>click here</Link> to login.
                  </Txt>
                  <Txt sx={{ color: grey[700], fontStyle: "italic" }}>
                    For example, if you started the login in Google Chrome, but
                    after clicking the link in your email you are brought to
                    Microsoft Edge, the login will fail.
                  </Txt>
                </Flx>

                <Flx fw ac sx={{ justifyContent: "space-around" }} gap={1} wrap>
                  <Flx
                    column
                    gap={1}
                    sx={{ flexShrink: 1, flexBasis: "500px" }}
                  >
                    <Txt bold>To fix this & use your previous browser:</Txt>

                    <Txt sx={{ color: grey[700] }}>
                      <List
                        component="ol"
                        sx={{
                          pl: 4,
                          listStyleType: "decimal",
                          "& .MuiListItem-root": {
                            display: "list-item",
                            pl: 1,
                          },
                        }}
                      >
                        <ListItem component="li">
                          Go back to the login page in desired browser.
                        </ListItem>
                        <ListItem component="li">
                          Enter your email address again and click "Send Magic
                          Link".
                        </ListItem>
                        <ListItem component="li">
                          Go to your email inbox and find the magic link email.
                        </ListItem>
                        <ListItem component="li">
                          Do not click the button, but instead, right click the
                          button and press "Copy link" or "Copy link address"
                        </ListItem>
                        <ListItem component="li">
                          Go back to the browser where you entered your email
                          address and paste the link into the address bar. Press
                          enter.
                        </ListItem>
                      </List>
                    </Txt>
                  </Flx>
                  <Box
                    component="img"
                    src={magicLinkGuide}
                    sx={{
                      p: 1,
                      borderRadius: "8px",
                      border: `1px solid ${grey[300]}`,
                      width: "100%",
                      maxWidth: "380px",
                      height: "auto",
                    }}
                  />
                </Flx>
              </Flx>
            </Card>
          </Box>
        </Flx>
      </Container>
    );
  }

  return (
    <Box
      sx={{
        height: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <CircularProgress />
      <Typography sx={{ mt: 2 }}>Authenticating…</Typography>
    </Box>
  );
};

export default Authenticate;
